import { config } from './config.js';
import { WishlistCollectionReference } from '../../@types/wishlist.js';
import { AbstractApi } from './abstract-api.js';

interface WishlistAdd {
  syan: number;
  colorId?: string;
  articleId?: string;
  added?: string;
  purchased?: string;
  notifyOnBackInStock?: string;
  collectionReferences?: WishlistCollectionReference[];
}

interface WishlistRemove {
  syan: number;
  colorId?: string;
}

export interface WishlistApi {
  add(data: WishlistAdd): Promise<boolean>;

  remove(data: WishlistRemove): Promise<boolean>;

  merge(): Promise<boolean>;
}

class WishlistApiClass extends AbstractApi implements WishlistApi {
  async add(data: WishlistAdd): Promise<boolean> {
    if (data.syan === undefined) {
      return false;
    }
    return this.post(`${config.apiEndpoint}item`, 'Wishlist', data);
  }

  async remove(data: WishlistRemove): Promise<boolean> {
    if (data.syan === undefined) {
      return false;
    }
    return this.delete(`${config.apiEndpoint}item`, 'Wishlist', data);
  }

  async merge(): Promise<boolean> {
    return this.post(`${config.apiEndpoint}merge`, 'Wishlist', {});
  }
}

export const WishlistApiInstance: WishlistApi = new WishlistApiClass();
